module.exports = __webpack_public_path__ + "catalog/items/firesafety/Phone-Green/Phone-Green.svg";